import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
} from "@mui/material";
import logoAbexa from "../../assets/images/LogoAbexa_BN.png";

import {
  soloDNI,
  soloCelular,
  soloCarnetExtranjeria,
} from "../../utils/utils";
import { useRegiones } from "../../hooks/useRegiones";
import { useEmpresas } from "../../hooks/useEmpresas";
import { useReclamo } from "../../hooks/registros/useReclamo";

export const RegistroReclamaciones = () => {
  const { reclamo, guardarReclamo, editarValorReclamo } = useReclamo();
  const {
    departamentos,
    obtenerDepartamentos,
    provincias,
    obtenerProvincias,
    distritos,
    obtenerDistritos,
  } = useRegiones();
  const { empresas, obtenerEmpresas } = useEmpresas();
  const [tipoDocumento, setTipoDocumento] = useState(1);

  useEffect(() => {
    obtenerDepartamentos();
    obtenerEmpresas();
  }, []);
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        py: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Card
        elevation={4}
        sx={{
          width: "100%",
          maxWidth: 750,
          mx: 2,
          borderRadius: 3,
        }}
      >
        <CardContent>
          <Box textAlign="center" mb={3}>
            <img src={logoAbexa} alt="Abexa logo" width={300} />
          </Box>
          <Typography variant="body1" color="textSecondary" align="center" mb={3}>
            En Biix, estamos comprometidos con brindar un servicio excepcional a nuestros clientes.<br />
            Si ha tenido alguna experiencia insatisfactoria, utilice este libro de reclamaciones para que podamos atenderlo de manera inmediata y efectiva.
          </Typography>

          <Typography variant="h6" mb={2}>
            Datos personales
          </Typography>

          {/* Personal Info */}
          <Box display="flex" flexWrap="wrap" gap={2} mb={2}>
            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "48%" } }}>
              <InputLabel>Tipo de Documento</InputLabel>
              <Select
                label="Tipo de Documento"
                value={reclamo.codDocumento || tipoDocumento}
                onChange={(e) => {
                  setTipoDocumento(Number(e.target.value));
                  editarValorReclamo("codDocumento", e.target.value);
                }}
              >
                <MenuItem value={1}>DNI</MenuItem>
                <MenuItem value={2}>Carné Extranjería</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Documento"
              value={reclamo.nroDocumento || ""}
              fullWidth
              autoFocus
              sx={{ flex: { xs: "100%", sm: "48%" } }}
              onChange={(e) =>
                editarValorReclamo("nroDocumento", e.target.value)
              }
              onKeyPress={(e) =>
                tipoDocumento === 1
                  ? soloDNI(e, e.target)
                  : soloCarnetExtranjeria(e, e.target)
              }
            />

            <TextField
                label="Nombres"
                value={reclamo.nomPersona || ""}
                fullWidth
                sx={{ flex: { xs: "100%", sm: "48%" } }}
                onChange={(e) =>
                  editarValorReclamo("nomPersona", e.target.value)
                }
            />

            <TextField
                label="Apellido Paterno"
                value={reclamo.apePaterno || ""}
                fullWidth
                sx={{ flex: { xs: "100%", sm: "48%" } }}
                onChange={(e) =>
                  editarValorReclamo("apePaterno", e.target.value)
                }
            />

            <TextField
                label="Apellido Materno"
                value={reclamo.apeMaterno || ""}
                fullWidth
                sx={{ flex: { xs: "100%", sm: "48%" } }}
                onChange={(e) =>
                  editarValorReclamo("apeMaterno", e.target.value)
                }
            />

            <TextField
                label="Teléfono"
                value={reclamo.telefono || ""}
                fullWidth
                sx={{ flex: { xs: "100%", sm: "48%" } }}
                onChange={(e) =>
                    editarValorReclamo("telefono", e.target.value)
                }
                onKeyPress={(e) => soloCelular(e, e.target)}
            />

            <TextField
                label="Email"
                type="email"
                value={reclamo.email || ""}
                fullWidth
                sx={{ flex: "100%" }}
                onChange={(e) =>
                  editarValorReclamo("email", e.target.value)
                }
            />
          </Box>

          <Typography variant="h6" mb={2} mt={3}>
            Detalle del reclamo
          </Typography>

          {/* Reclamo Info */}
          <Box display="flex" flexWrap="wrap" gap={2} mb={2}>
            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "32%" } }}>
              <InputLabel>Departamento</InputLabel>
              <Select
                label="Departamento"
                defaultValue={departamentos.CodDepartamento}
                onChange={async (e) => {
                    await obtenerProvincias(e.target.value);
                    editarValorReclamo(
                      "departamento",
                      (Number(e.target.value) !== 0 ? 
                        departamentos.find((d) => d.CodDepartamento === e.target.value)?.NomDepartamento || ""
                        : "")
                    )
                }}
              >
                <MenuItem key="opc-0-dep" value="0">--Seleccione--</MenuItem>
                {departamentos.map((d,i) => (
                  <MenuItem  key={i + '_' + d.CodDepartamento}  value={d.CodDepartamento}>
                    {d.NomDepartamento}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "32%" } }}>
              <InputLabel>Provincia</InputLabel>
              <Select
                label="Provincia"
                    defaultValue={provincias.CodProvincia}  
                onChange={(e) => {
                  obtenerDistritos(e.target.value);
                  editarValorReclamo(
                    "provincia",
                    (
                      Number(e.target.value) !== 0 ? 
                        provincias.find((p) => p.CodProvincia === e.target.value)?.NomProvincia || ""
                      : ""
                    )
                  );
                }}
              >
                <MenuItem value="0">--Seleccione--</MenuItem>
                {provincias.map((p) => (
                  <MenuItem key={p.CodProvincia} value={p.CodProvincia}>
                    {p.NomProvincia}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "32%" } }}>
              <InputLabel>Distrito</InputLabel>
              <Select
                label="Distrito"
                onChange={(e) =>
                  editarValorReclamo(
                    "distrito",
                    (
                      Number(e.target.value) !== 0 ? 
                        distritos.find((d) => d.CodDistrito === e.target.value)?.NomDistrito || ""
                      : ""
                    )
                  )
                }
              >
                <MenuItem value="0">--Seleccione--</MenuItem>
                {distritos.map((d) => (
                  <MenuItem key={d.CodDistrito} value={d.CodDistrito}>
                    {d.NomDistrito}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "66%" } }}>
              <InputLabel>Empresa</InputLabel>
              <Select
                label="Empresa"
                dafaultvalue={reclamo.codEmpresaGeneral || ""}
                onChange={(e) => {
                  editarValorReclamo("codEmpresaGeneral", Number(e.target.value))
                  editarValorReclamo("nomEmpresaGeneral", 
                    Number(e.target.value) !== 0 ? 
                    empresas.find((emp) => emp.codEmpresa === Number(e.target.value))?.nomEmpresa || "" 
                    : ""
                  )

                }}
              >
                <MenuItem value="0">--Seleccione--</MenuItem>
                {empresas.map((emp) => (
                  <MenuItem key={emp.codEmpresa} value={emp.codEmpresa}>
                    {emp.nomEmpresa}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ flex: { xs: "100%", sm: "32%" } }}>
              <InputLabel>Tipo</InputLabel>
              <Select
                label="Tipo"
                value={reclamo.codTipoConsulta || 1}
                onChange={(e) =>
                  editarValorReclamo("codTipoConsulta", Number(e.target.value))
                }
              >
                <MenuItem value={1}>Reclamo</MenuItem>
                <MenuItem value={2}>Queja</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Coméntanos lo sucedido"
              value={reclamo.detalleReclamo || ""}
              onChange={(e) =>
                editarValorReclamo("detalleReclamo", e.target.value)
              }
              fullWidth
              multiline
              minRows={4}
              sx={{ flex: "100%" }}
              placeholder="Describe tu experiencia"
            />
          </Box>

          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            mb={2}
          >
            Agradecemos su confianza en nuestro libro de reclamaciones.
            Sus comentarios y sugerencias son muy valiosos para nosotros y nos permiten mejorar continuamente.
            Esperamos haber atendido todas sus inquietudes de manera efectiva.
          </Typography>

          <Box textAlign="center" mt={2}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ px: 5, py: 1.5, borderRadius: 2 }}
              onClick={guardarReclamo}
            >
              ENVIAR
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
